import Plugin from "@wielink/datatables/Plugins/Plugin";

class RowReorder extends Plugin {
	init() {
        this.datatable.api().on( 'row-reorder', this.reorder.bind(this));
	}

    async reorder(event, diff, edit ) {

        let url = this.config.ajax.prioUpdateUrl ;
        let updatedPrios = {};
        for ( var i=0, ien=diff.length ; i<ien ; i++ ) {
            var rowData = this.datatable.api().row( diff[i].node ).data();
            updatedPrios[rowData.id] = diff[i].newPosition + 1;
        }
        let result = Helpers.Ajax.post(url,{
            objects : updatedPrios
        }, {
            'afterSuccess' : (response) => {
                this.datatable.api().ajax.reload();
            }
        });
        return true;
    }
}

export default RowReorder;